import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#141414] flex flex-col">
      <Header />
      <div className="flex-1 container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">
          Politique de Confidentialité – H4KIG STREAM
        </h1>
        <p className="text-gray-400 text-sm mb-10">
          Version en vigueur au 31 janvier 2026
        </p>

        <div className="prose prose-invert prose-lg max-w-none space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Responsable du traitement</h2>
            <p>
              <strong>H4KIG</strong>
            </p>
            <p>
              Contact : <a href="mailto:support@h4kig.us" className="text-white hover:text-blue-400 transition">support@h4kig.us</a> | Telegram : <a href="https://t.me/H4KIG" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition">@H4KIG</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Données collectées</h2>
            <p>Nous collectons uniquement les données nécessaires au fonctionnement du Service :</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li><strong>Données techniques :</strong> adresse IP, type d'appareil, navigateur, système d'exploitation, horodatages ;</li>
              <li><strong>Données d'utilisation :</strong> contenus visionnés, recherches effectuées, historique de lecture, favoris, progression de visionnage ;</li>
              <li><strong>Données de compte</strong> (si vous créez un compte) : email, pseudo, préférences, mot de passe (haché) ;</li>
              <li><strong>Cookies et technologies similaires :</strong> pour gérer la session, les préférences d'interface (langue, thème, etc.) et les statistiques d'usage anonymes.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Finalités du traitement</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Permettre l'accès et le bon fonctionnement du Service ;</li>
              <li>Personnaliser votre expérience (recommandations, reprise de lecture, liste « Continuer à regarder ») ;</li>
              <li>Analyser l'usage global afin d'améliorer la plateforme ;</li>
              <li>Gérer votre compte et répondre à vos demandes de support ;</li>
              <li>Détecter et prévenir les abus, fraudes ou violations des conditions ;</li>
              <li>Respecter nos obligations légales.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Partage des données</h2>
            <p>
              Nous ne vendons pas vos données et ne les partageons pas à des fins marketing.
            </p>
            <p>Vos données peuvent être transmises à :</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>des prestataires techniques (hébergement, CDN, outils d'analyse anonymisés) qui agissent en notre nom et sur nos instructions ;</li>
              <li>des autorités compétentes en cas d'obligation légale ou pour protéger nos droits.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Durée de conservation</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Logs techniques</strong> → maximum 12 mois ;</li>
              <li><strong>Données liées à votre compte et historique de visionnage</strong> → tant que votre compte est actif, puis jusqu'à 6 mois après sa suppression (sauf obligation légale plus longue).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Vos droits</h2>
            <p>
              Conformément au RGPD (pour les utilisateurs de l'UE) et aux lois applicables, vous disposez des droits d'accès, de rectification, d'effacement, de limitation du traitement, de portabilité des données et d'opposition.
            </p>
            <p>
              Pour exercer ces droits, contactez-nous à <a href="mailto:support@h4kig.us" className="text-white hover:text-blue-400 transition">support@h4kig.us</a>. Nous répondrons dans un délai d'un mois maximum.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Évolution de la politique</h2>
            <p>
              Cette politique peut être modifiée. La version en vigueur est toujours celle publiée sur le Service. En cas de changements importants, nous vous informerons par email ou notification dans l'application.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
